import React from 'react'
import { Box, Typography, Button, IconButton } from '@mui/material'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import DeleteIcon from '@mui/icons-material/Delete'
import { getSupportedVideoFormats } from '../utils/videoUtils'
import { useVideoUploader } from '../hooks/useVideoUploader'
import { getVideoUploaderStyles } from '../styles/videoStyles'
import VideoViewer from './VideoViewer'

export default function VideoUploader({ url, onVideoChange, onVideoRemove, topicId, isCurrentThemeLight = false }) {
  const {
    localUrl,
    error,
    isLoading,
    isHovering,
    handleVideoUpload,
    handleRemoveVideo,
    handleMouseEnter,
    handleMouseLeave
  } = useVideoUploader({ url, onVideoChange, onVideoRemove, topicId })

  const styles = getVideoUploaderStyles(isCurrentThemeLight)

  return (
    <Box sx={styles.videoContainer}>
      {localUrl ? (
        <Box sx={styles.videoPreview} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <VideoViewer url={localUrl} alt='Video preview' />
          {isHovering && (
            <IconButton onClick={handleRemoveVideo} sx={styles.deleteButton} aria-label='delete video'>
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      ) : (
        <Box sx={styles.videoPlaceholder}>
          <>
            <VideoLibraryIcon style={styles.videoIcon} />
            <Box sx={styles.buttonContainer}>
              <input
                accept={getSupportedVideoFormats().join(',')}
                style={{ display: 'none' }}
                id='video-upload'
                type='file'
                onChange={handleVideoUpload}
                disabled={isLoading}
              />
              <label htmlFor='video-upload'>
                <Button variant='contained' component='span' sx={styles.uploadButton} disabled={isLoading}>
                  {isLoading ? 'Uploading...' : 'Upload Video'}
                </Button>
              </label>
            </Box>
            <Typography variant='caption' color='text.secondary' sx={styles.maxSizeInfo}>
              Max 450MB (MP4, WebM)
            </Typography>
            {error && (
              <Typography variant='caption' color='error' sx={styles.errorText}>
                {error}
              </Typography>
            )}
          </>
        </Box>
      )}
    </Box>
  )
}
